import axiosInstance from 'shared/services/api/axiosInstance';

function teamParams(teamId) {
  return { team_id: teamId };
}

export async function listAnnotations(teamId, conversationId) {
  const { data } = await axiosInstance.get('/annotations', {
    params: { ...teamParams(teamId), conversation_id: conversationId },
  });
  return data?.annotations || [];
}

export async function listAnnotationsForRun(teamId, runId, conversationId) {
  const { data } = await axiosInstance.get('/annotations', {
    params: {
      ...teamParams(teamId),
      run_id: runId,
      ...(conversationId ? { conversation_id: conversationId } : {}),
    },
  });
  return data?.annotations || [];
}

export async function createAnnotation(teamId, payload) {
  const { data } = await axiosInstance.post('/annotations', {
    conversation_id: payload.conversationId,
    context_type: payload.context?.type || 'conversation',
    run_id: payload.context?.type === 'run' ? payload.context.id : payload.context?.runId,
    span_id: payload.context?.type === 'span' ? payload.context.id : undefined,
    span_started_at: payload.context?.type === 'span' ? payload.context.startedAt : undefined,
    body: payload.body,
    mentioned_user_ids: (payload.mentions || []).map((m) => m.userId),
  }, { params: teamParams(teamId) });
  return data?.annotation;
}

export async function replyToAnnotation(teamId, annotationId, payload) {
  const { data } = await axiosInstance.post(`/annotations/${encodeURIComponent(annotationId)}/replies`, {
    body: payload.body,
    mentioned_user_ids: (payload.mentions || []).map((m) => m.userId),
  }, { params: teamParams(teamId) });
  return data?.annotation;
}

export async function updateAnnotation(teamId, annotationId, payload) {
  const { data } = await axiosInstance.patch(`/annotations/${encodeURIComponent(annotationId)}`, {
    body: payload.body,
    mentioned_user_ids: (payload.mentions || []).map((m) => m.userId),
  }, { params: teamParams(teamId) });
  return data?.annotation;
}

export async function deleteAnnotation(teamId, annotationId) {
  await axiosInstance.delete(`/annotations/${encodeURIComponent(annotationId)}`, {
    params: teamParams(teamId),
  });
}

export async function fetchAnnotationCounts(teamId, { conversationIds = [], runIds = [], spans = [] }) {
  const { data } = await axiosInstance.post('/annotations/counts', {
    conversation_ids: conversationIds,
    run_ids: runIds,
    spans,
  }, { params: teamParams(teamId) });
  return data || { conversations: {}, runs: {}, spans: {} };
}

export async function fetchMentionUsers(teamId) {
  const { data } = await axiosInstance.get('/annotations/users', {
    params: teamParams(teamId),
  });
  return data?.users || [];
}

export function addMention(mentions, user) {
  if (!user) return mentions || [];
  const list = mentions || [];
  if (list.some((m) => Number(m.userId) === Number(user.id))) return list;
  return [...list, { userId: user.id, displayName: user.name }];
}
